"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const expressions_1 = require("@mwater/expressions");
const ExprElementBuilder_1 = __importDefault(require("./ExprElementBuilder"));
const contexts_1 = require("./contexts");
/** Display/editor component for an expression
 * Uses ExprElementBuilder to create the tree of components
 * Cleans expression as a convenience
 */
function ExprComponent(props) {
    const locale = (0, react_1.useContext)(contexts_1.LocaleContext);
    /** Clean expression and pass up */
    const handleChange = (expr) => {
        props.onChange(cleanExpr(expr));
    };
    /** Cleans an expression */
    const cleanExpr = (expr) => {
        return new expressions_1.ExprCleaner(props.schema).cleanExpr(expr, {
            table: props.table,
            types: props.types,
            enumValueIds: props.enumValues ? props.enumValues.map(ev => ev.id) : undefined,
            idTable: props.idTable,
            aggrStatuses: !props.table ? ["literal"] : props.aggrStatuses || ["individual", "literal"]
        });
    };
    const expr = cleanExpr(props.value);
    return react_1.default.createElement(react_1.default.Fragment, null, new ExprElementBuilder_1.default(props.schema, props.dataSource, locale).build(expr, props.table, props.onChange ? handleChange : undefined, {
        types: props.types,
        enumValues: props.enumValues,
        preferLiteral: props.preferLiteral,
        idTable: props.idTable,
        includeAggr: (props.aggrStatuses || ["individual", "literal"]).includes("aggregate"),
        aggrStatuses: !props.table ? ["literal"] : props.aggrStatuses || ["individual", "literal"],
        placeholder: props.placeholder,
        refExpr: props.refExpr,
    }));
}
exports.default = ExprComponent;
